import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  AppBar,
  Card,
  CardContent,
  Grid,
  Paper,
  Tab,
  Tabs,
} from '@material-ui/core';
import { TabContainer } from '../custom-tab-container/custom-tab-container';
/*** Program Selector */
import FormFieldsTabProgramsTabPrograms from './tab-programs/tab-programs';
/*** Modules / Programs */
import BOPModuleProgramRequirements from './BOP-Module/tab-BOP-Program-Requirements/tab-BOP-Program-Requirements';
import BOPModuleInstitution from './BOP-Module/tab-BOPInstitution/tab-BOPInstitution';
import BOPModuleGangAffiliation from './BOP-Module/tab-BOP-Gang-Affiliation/tab-BOP-Gang-Affiliation';

import FormFieldsTabAllSupervision from './ALL-Assigned-CJ-Supervision/tab-all-supervision';
import FormFieldsTabAllClinicalProviders from './ALL-Clinical-Providers-At-Referral/tab-all-clinical-providers';

class FormFieldsTabPrograms extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      headerTabs: 0,
      showHideProgram: props.programSelected,
    };
  }
  handleProgramHeaderChange = (event, value) => {
    event.persist();
    this.setState({ headerTabs: value });
  }
  handleProgramChange = (event, value) => {
    // event.persist();
    this.setState({ showHideProgram: value });
  }
  render() {
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>
              <Grid container spacing={3}>

                <AppBar position="static" color="default">
                  <Tabs
                    value={this.state.headerTabs}
                    onChange={this.handleProgramHeaderChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                                                                                                            // scrollButtons="auto"
                    scrollButtons="on"
                  >

                    {/* REQUIRED */}
                    {/* Program Selector */}
                    <Tab label="Program Assigned" /> {/* 0 */}


                    {/* All Programs Details Tab Headers - START */}
{/*
                                                                                                          {this.state.showHideProgram === '1' ? <Tab value={11} label="Assigned CJ Supervision" /> : '' }
                                                                                                          {this.state.showHideProgram === '1' ? <Tab value={12} label="Clinical Providers" /> : '' }
*/}
                    {this.state.showHideProgram > 0 ? <Tab value={11} label="Criminal Justice Supervision" /> : '' }
                    {this.state.showHideProgram > 0 ? <Tab value={12} label="Clinical Providers" /> : '' }
                    {/* All Programs Details Tab Headers - END */}

                    {/* Modules / Programs Tab Headers - START */}
                    {/* BOP RRC Module */}
                                                                                      {/* {this.state.showHideProgram === '1' ? <Tab value={101} label="BOP Officer" /> : '' } */}
                    {this.state.showHideProgram === '1' ? <Tab value={102} label="BOP Program Requirements" /> : '' }
                    {this.state.showHideProgram === '1' ? <Tab value={103} label="BOP Institution" /> : '' }
                    {this.state.showHideProgram === '1' ? <Tab value={104} label="BOP Gang Affiliation" /> : '' }
                                                                                      {/*** OPC US PTS-Psy Module */}
                                                                                      {/* {this.state.showHideProgram === '4' ? <Tab value={140} label="OPC US PTS-Psy Officer" /> : '' } */}
                                                                                      {/* Modules / Programs Tab Headers - END */}
                  </Tabs>
                </AppBar>

                {/* REQUIRED */}
                {/* Program Selector */}
                {this.state.headerTabs === 0 && <TabContainer>
                  <FormFieldsTabProgramsTabPrograms
                    locked={this.props.programOptionsMode === 1 ? true : this.props.locked}
                    initialValues={this.props.referralMode === 0 ? this.state.referralEntry : this.props.referralEntry}
                    programsList={this.props.programsList}
                    changeProgram={this.handleProgramChange}
                    allowChangeProgram={this.props.allowChangeProgram}
                    handleSubmitChangeProgram={this.props.handleSubmitChangeProgram}
                  />
                </TabContainer>}


                {/*** All Programs Details - START */}
                {this.state.showHideProgram > 0 ? <>

                  {this.state.headerTabs === 11 && <TabContainer>
                    <FormFieldsTabAllSupervision
                      locked={this.props.programOptionsMode === 1 ? true : this.props.locked}
                      programSelected={this.state.showHideProgram}
                                                                                          // locked={this.props.locked}
                                                                                          // initialValues={this.props.referralMode === 0 ? this.state.referralEntry : this.props.referralEntry}
                    />
                  </TabContainer>}

                  {this.state.headerTabs === 12 && <TabContainer>
                    <FormFieldsTabAllClinicalProviders
                      locked={this.props.programOptionsMode === 1 ? true : this.props.locked}
                                                                                          // locked={this.props.locked}
                                                                                          // initialValues={this.props.referralMode === 0 ? this.state.referralEntry : this.props.referralEntry}
                    />
                  </TabContainer>}

                </> : '' }
                {/*** All Programs Details - END */}



                {/* Modules / Programs */}
                {/*** BOP RRC Module - START */}
                {this.state.showHideProgram === '1' ? <>

                  {this.state.headerTabs === 101 && <TabContainer>
                                                                                        {/* <BOPModuleOfficer
                                                                                          locked={this.props.locked}
                                                                                          initialValues={this.props.referralMode === 0 ? this.state.referralEntry : this.props.referralEntry}
                                                                                        /> */}
                  </TabContainer>}
                  {this.state.headerTabs === 102 && <TabContainer>
                    <BOPModuleProgramRequirements
                      locked={this.props.programOptionsMode === 1 ? true : this.props.locked}
                                                                                          // locked={this.props.locked}
                                                                                          // initialValues={this.props.referralMode === 0 ? this.state.referralEntry : this.props.referralEntry}
                    />
                  </TabContainer>}
                  {this.state.headerTabs === 103 && <TabContainer>
                    <BOPModuleInstitution
                      locked={this.props.programOptionsMode === 1 ? true : this.props.locked}
                      bopinstitutionsList={this.props.bopinstitutionsList}
                                                                                          // locked={this.props.locked}
                                                                                          // initialValues={this.props.referralMode === 0 ? this.state.referralEntry : this.props.referralEntry}
                    />
                  </TabContainer>}
                  {this.state.headerTabs === 104 && <TabContainer>
                    <BOPModuleGangAffiliation
                      locked={this.props.programOptionsMode === 1 ? true : this.props.locked}
                      gangaffiliationsList={this.props.gangaffiliationsList}
                                                                                          // locked={this.props.locked}
                                                                                          // initialValues={this.props.referralMode === 0 ? this.state.referralEntry : this.props.referralEntry}
                    />
                  </TabContainer>}

                </> : '' }
                {/*** BOP RRC Module - END */}

              </Grid>
            </CardContent>
          </Card>
        </Paper>
      </div>

    );
  }
}
FormFieldsTabPrograms.defaultProps = {
  programOptionsMode: 0,
  programSelected: PropTypes.number,
};
FormFieldsTabPrograms.propTypes = {
  /*** fix make required */
  locked: PropTypes.bool,
  programOptionsMode: PropTypes.number,
  allowChangeProgram: PropTypes.bool,
  /*** fix make required */
  programsList: PropTypes.array,
  bopinstitutionsList: PropTypes.array,
  gangaffiliationsList: PropTypes.array,
  /*** function provided by parent */
  handleSubmitChangeProgram: PropTypes.func,
};
export default FormFieldsTabPrograms;